<script setup>
import AuthLayout from '@/layouts/AuthLayout.vue';
import RegisterFormComponent from '@/components/RegisterFormComponent.vue';
</script>

<template>
  <AuthLayout>
    <template #content>
      <section class="container py-32 z-10 relative h-full flex-grow">
        <div
          class="flex flex-col flex-1 max-w-md lg:max-w-4xl mx-auto justify-center items-center h-full lg:space-x-5"
        >
          <div class="w-full lg:w-4/6 mb-4 lg:mb-0 text-center">
            <h2 class="mb-5 text-5xl text-green-700 font-semibold">
              <span class="text-3xl text-red-300 block mb-5">Welcome</span> Ghana Connect
            </h2>
            <h1 class="text-4xl text-amber-500 border-b border-amber-500 inline">
              Register
            </h1>
            <p class="text-base text-gray-600 mt-5">
              Hello guest, thank you for joining us.
            </p>
          </div>
          <div class="w-full lg:w-4/6">
            <RegisterFormComponent />
          </div>
        </div>
      </section>
    </template>
  </AuthLayout>
</template>

<style scoped></style>
